export enum SharePointUserType {
  DirectoryGroup = "DirectoryGroup",
  SharePointGroup = "SharePointGroup",
  User = "User"
}
